module.exports = __webpack_public_path__ + "media/src/assets/images/lps-life_event_sp-8799435b9a42383b996dcbed4f6e09fb.png";